import React from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  Typography,
  useTheme,
} from '@mui/material';
import { Info } from 'react-feather';
import { CleanButton } from 'src/components/clean/button';

interface PrefillNotificationModalProps {
  open: boolean;
  onClose: () => void;
}

const PrefillNotificationModal: React.FC<PrefillNotificationModalProps> = ({ open, onClose }) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      aria-labelledby="prefill-notification-dialog"
      sx={{
        '& .MuiDialog-paper': {
          backgroundColor: theme.palette.background.paper,
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
          borderRadius: 2,
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
        //   backgroundColor: theme.palette.info.main,
          px: 3,
          py: 2,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          backgroundColor: '#2196F3',
        }}
      >
        <Info size={20} color={'#ffffff'} />
        <Typography variant="h6" sx={{ color: '#ffffff' }}>
          Review your information
        </Typography>
      </Box>

      {/* Content */}
      <DialogContent sx={{ pt: 3 }}>
        <DialogContentText sx={{ color: 'text.primary' }}>
          We've pre-filled your application with information from your last visit to save you time. Please review the
          details carefully and make any necessary updates to ensure everything is accurate.
        </DialogContentText>

        <Paper
          elevation={0}
          sx={{
            mt: 2,
            mb: 2,
            p: 2,
            bgcolor: 'grey.50',
            borderRadius: 1,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Info size={18} color={'#2196F3'} />
            <Typography variant="body1" sx={{ fontWeight: 500, color: '#2196F3' }}>
            Some fields might be empty and need your attention.
            </Typography>
          </Box>
          <Typography variant="body2" sx={{ color: 'text.primary', mt: 1 }}>
           We used the information we had on file, which means we might not have everything. Please fill in any missing details.
          </Typography>
        </Paper>
      </DialogContent>

      {/* Actions */}
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <CleanButton 
          onClick={onClose} 
          color="primary" 
          variant="contained"
          sx={{
            backgroundColor: '#2196F3',
            '&:hover': {
              backgroundColor: '#1976D2'
            }
          }}
        >
          Close
        </CleanButton>
      </DialogActions>
    </Dialog>
  );
};

export default PrefillNotificationModal;